import React from 'react'
import { Box, Cone, Sphere, Torus, TorusKnot, Dodecahedron } from 'drei'
// import { useControl } from 'react-three-gui'
import GenesysBase from '../genesysBase'
// import useStore from '../../store'
import objects from '../../config/objects.json'

const ids = Object.keys(objects)
const Geometrys = { Sphere, Box, Cone, TorusKnot, Torus, Dodecahedron }

// const onClick = async () => {
//   const { transforms } = useStore.getState()
//   const allIds = Object.keys(transforms)
  
//   const updated = allIds.reduce((prev, id) => ({
//     ...prev,
//     [id]: {
//       ...objects[id],
//       ...transforms[id]
//     }
//   }), {})

//   const fileName = "file";
//   const json = JSON.stringify(updated);
//   const blob = new Blob([json],{type:'application/json'});
//   const href = await URL.createObjectURL(blob);
//   const link = document.createElement('a');
//   link.href = href;
//   link.download = fileName + ".json";
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// }

const Objects = ({ history }) => {
  // useControl('Salvar', { type: 'button', onClick })

  return ids.map((id) => {
    if (!objects[id].geometry) return null
    return (
      <GenesysBase
        key={id}
        id={id}
        Geometry={Geometrys[objects[id].geometry]}
        config={objects[id]}
        history={history}
      />
    )
  })
}

export default Objects
